var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('search.top_users'))+" ")]),_vm._l((_vm.users),function(user){return _c('SearchResult',{key:user.idt_user,attrs:{"search-result":user}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }